module.exports = __webpack_public_path__ + "static/media/logo_motorola.306c5810.png";